import { type ServiceMethod } from '@/application/interfaces/service';

type LoyaltyProfessional = {
  documentation?: {
    id?: string;
    picture?: string;
  };
};

type LoyaltyPoints = {
  actual?: number;
  season?: {
    balance: number;
    toExpire: number;
    expireAt: string;
  };
  toExpire?: number;
  expireAt?: string;
};

type LoyaltyExternalCatalog = {
  slug?: string;
  url?: string;
  banners?: {
    desktop?: string;
    mobile?: string;
  };
};

type LoyaltyProfile = {
  name: string;
  picture: string | null;
  points: LoyaltyPoints;
  occupation: string | null;
  professional: LoyaltyProfessional | never[];
  status: number;
  hasPreferences: boolean;
  hasProfessionalRelationship: boolean;
  externalCatalogs?: LoyaltyExternalCatalog[];
  seasonEndsAt: string;
  hasArchitectCashback: boolean;
};

export interface Response {
  data: LoyaltyProfile;
}

const getLoyaltyProfile: ServiceMethod<Response> =
  (httpClient) => async (options) => {
    const { body } = await httpClient.get<Response, undefined, undefined>(
      `/api/v2/loyaltyProgram/profile`,
      options
    );

    return body;
  };

export default getLoyaltyProfile;
